"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTitleWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _FormTitleWrapperModule = _interopRequireDefault(require("./FormTitleWrapper.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FormTitleWrapper = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    iconType,
    iconName,
    iconSize = 'small',
    iconColor,
    title,
    rightSlot
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "FormTitleWrapper",
    className: _FormTitleWrapperModule.default.container
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_FormTitleWrapperModule.default.leftSection, classNames?.wrapper)
  }, !!iconName && /*#__PURE__*/React.createElement(_Icon.Icon, {
    type: iconType,
    name: iconName,
    size: iconSize,
    color: iconColor
  }), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_FormTitleWrapperModule.default.componentHousing, classNames?.title)
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_FormTitleWrapperModule.default.rightSection, classNames?.rightSlot)
  }, rightSlot));
});
exports.FormTitleWrapper = FormTitleWrapper;